module.exports = __webpack_public_path__ + "resources/img/img_tibero3_jp.b7391c694f357262d4bfe44592f8d329.png";